// extracted by mini-css-extract-plugin
export default {"switchAnswer":"styles_switchAnswer__Q8T4W","switchBadge":"styles_switchBadge__YmxpX","active":"styles_active__zm+b+"};